import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {IdentifyModalComponent} from '../../shared/identify-modal/identify-modal.component';

@Component({
  selector: 'qcc-success-modal',
  templateUrl: './qcc-success-modal.component.html',
  styleUrls: ['./qcc-success-modal.component.scss']
})
export class QccSuccessModalComponent {

  @Input() unauthenticated = false;
  @Output() showPositions = new EventEmitter<void>();

  @ViewChild('identifyModal') identifyModal: IdentifyModalComponent;

  seePositions() {
    this.showPositions.emit();
  }
}
